import dxPopup from 'devextreme/ui/popup';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import './assets/style.scss';

dxPopup.defaultOptions({
  options: {
    showCloseButton: true,
  },
});

const rootElement = document.getElementById('root');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  rootElement,
);

//registerServiceWorker();
